var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_61_1373)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7,
    r: 7,
    fill: "#FBCB4E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_61_1373)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.9985,
    cy: 7.00017,
    r: 6.06667,
    fill: "#FFCF52"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_61_1373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6423 5.15892C12.6021 4.80244 12.4364 4.52629 12.1452 4.33047C11.854 4.13215 11.4875 4.03299 11.0456 4.03299C10.7293 4.03299 10.4557 4.0832 10.2247 4.18361C9.99376 4.28152 9.81426 4.41708 9.68623 4.5903C9.56071 4.76101 9.49794 4.95557 9.49794 5.17398C9.49794 5.35724 9.54062 5.5154 9.62598 5.64845C9.71384 5.78151 9.82807 5.89322 9.96865 5.9836C10.1117 6.07146 10.2649 6.14552 10.4281 6.20577C10.5912 6.26351 10.7481 6.31121 10.8988 6.34887L11.6519 6.54468C11.8979 6.60493 12.1502 6.68652 12.4088 6.78945C12.6674 6.89238 12.9071 7.02794 13.128 7.19614C13.349 7.36434 13.5272 7.5727 13.6628 7.82124C13.8008 8.06977 13.8699 8.36726 13.8699 8.7137C13.8699 9.15051 13.7569 9.53838 13.531 9.87729C13.3075 10.2162 12.9824 10.4836 12.5557 10.6794C12.1314 10.8752 11.618 10.9731 11.0155 10.9731C10.4381 10.9731 9.93853 10.8815 9.51677 10.6982C9.09502 10.5149 8.7649 10.2551 8.52641 9.91871C8.28791 9.5798 8.15612 9.17813 8.13101 8.7137H9.29836C9.32096 8.99236 9.41133 9.22457 9.56949 9.41034C9.73016 9.59361 9.93476 9.73042 10.1833 9.8208C10.4343 9.90867 10.7092 9.9526 11.008 9.9526C11.3368 9.9526 11.6293 9.90113 11.8854 9.79821C12.1439 9.69277 12.3473 9.54716 12.4954 9.36139C12.6435 9.17311 12.7176 8.95344 12.7176 8.7024C12.7176 8.47395 12.6523 8.28692 12.5218 8.14132C12.3937 7.99571 12.2193 7.87521 11.9983 7.77981C11.7799 7.68442 11.5327 7.60032 11.2565 7.52752L10.3452 7.27898C9.72765 7.11078 9.23811 6.86351 8.87661 6.53715C8.51762 6.21079 8.33812 5.779 8.33812 5.24176C8.33812 4.79742 8.45862 4.40955 8.69963 4.07818C8.94063 3.7468 9.26698 3.48948 9.6787 3.30622C10.0904 3.12044 10.5548 3.02756 11.072 3.02756C11.5942 3.02756 12.0548 3.11919 12.454 3.30245C12.8557 3.48571 13.172 3.73801 13.4029 4.05935C13.6339 4.37817 13.7544 4.7447 13.7644 5.15892H12.6423Z",
    fill: "#B28C2D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_61_1373",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_1373"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_61_1373",
    result: "effect2_dropShadow_61_1373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_61_1373",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_61_1373",
    x: 4.93179,
    y: 0.933502,
    width: 12.1333,
    height: 12.1333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.679104 0 0 0 0 0.0798438 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1373"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_61_1373",
    x: 8.13101,
    y: 3.02756,
    width: 5.73886,
    height: 7.94553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.682353 0 0 0 0 0.235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1373"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinHome);
export default __webpack_public_path__ + "static/media/CoinHome.053f80f809b11b7ba501ead32ffe0d87.svg";
export { ForwardRef as ReactComponent };